"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5095],{

/***/ 86203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v5_OtherProviders; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./src/components/v5/SkipSection.tsx
var SkipSection = __webpack_require__(84661);
// EXTERNAL MODULE: ./src/_services/featureFlagConstants.ts
var featureFlagConstants = __webpack_require__(72714);
// EXTERNAL MODULE: ./node_modules/lodash/identity.js
var identity = __webpack_require__(18594);
var identity_default = /*#__PURE__*/__webpack_require__.n(identity);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(7037);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/useMediaQuery.ts
var useMediaQuery = __webpack_require__(57974);
// EXTERNAL MODULE: ./src/_services/api.ts + 2 modules
var api = __webpack_require__(95832);
// EXTERNAL MODULE: ./src/hooks/useFeatureFlags.ts
var useFeatureFlags = __webpack_require__(15343);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
// EXTERNAL MODULE: ./src/components/_common/Carbon.tsx
var Carbon = __webpack_require__(29946);
// EXTERNAL MODULE: ./src/components/_common/LazyComp.tsx
var LazyComp = __webpack_require__(90008);
// EXTERNAL MODULE: ./node_modules/@c10h/colors/es/palette.js
var palette = __webpack_require__(45602);
// EXTERNAL MODULE: ./src/useS3ImgSrc.tsx
var useS3ImgSrc = __webpack_require__(52221);
// EXTERNAL MODULE: ./src/components/v5/NextImage.tsx + 1 modules
var NextImage = __webpack_require__(5621);
// EXTERNAL MODULE: ./src/components/v5/NextLink.tsx
var NextLink = __webpack_require__(10738);
// EXTERNAL MODULE: ./src/components/v5/ReadableSlotTime.tsx
var ReadableSlotTime = __webpack_require__(566);
;// CONCATENATED MODULE: ./src/components/v5/OtherProvider.tsx











const OtherProvider = (param)=>{
    let { doctor: { slug , firstName , lastName , profileImageId , credential , specialties , nextApptSlot , primaryLocation  }  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const isSm = (0,useMediaQuery/* default */.Z)("sm");
    const [isHovered, setIsHovered] = (0,react.useState)(false);
    const [isFocused, setIsFocused] = (0,react.useState)(false);
    const imageDimension = isSm ? 250 : 300;
    const formattedName = (0,Carbon/* formatName */.KY)(firstName, lastName, credential);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
        href: {
            pathname: _constants/* v5Pages.providers */.Td.providers,
            query: {
                slug
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            onFocus: ()=>{
                setIsFocused(true);
            },
            onBlur: ()=>{
                setIsFocused(false);
            },
            onMouseEnter: ()=>{
                setIsHovered(true);
            },
            onMouseLeave: ()=>{
                setIsHovered(false);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                className: "br2",
                style: {
                    outline: "3px solid ".concat(isFocused ? "blue" : "transparent"),
                    outlineOffset: 6
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "br50 oh df jcc aic",
                        style: {
                            height: imageDimension,
                            width: imageDimension
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                            "aria-hidden": true,
                            alt: formattedName,
                            width: imageDimension,
                            height: imageDimension,
                            quality: 80,
                            src: (0,useS3ImgSrc/* s3ImageSource */.Lv)(profileImageId, "jpg", 3)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("figcaption", {
                        className: "df fdc aic font-ir",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                className: "tac fs20 fs18-sm font-csb mt4 mb3 t-100 fsn",
                                style: {
                                    color: isHovered ? palette.gray400 : palette.gray800
                                },
                                children: formattedName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tac fs16 fs14sm mb1 t-100 gray800 lh16",
                                children: specialties.map((s)=>i18n.t(s)).slice(0, 3).join(", ")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "fs14 tac gray400 mb6",
                                children: primaryLocation === null || primaryLocation === void 0 ? void 0 : primaryLocation.name
                            }),
                            nextApptSlot && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "df jcc fs14 fs12-sm fdc-sm aic-sm jsfe font-mb",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        className: "gray600 op1 mv0 mr2 mr0-sm fsn ttu",
                                        children: i18n.t("Next available")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        className: "darkGreen mv0 mt2-sm op1 fsn ttu",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadableSlotTime/* ReadableSlotTime */.n, {
                                            time: nextApptSlot
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v5_OtherProvider = (OtherProvider);

;// CONCATENATED MODULE: ./src/components/v5/OtherProviders.tsx















const OtherProviders = (param)=>{
    let { header , tag , coordinate , filter =(identity_default()) , radius =3  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { width  } = (0,Carbon/* useWindowSize */.fy)();
    const isSm = (0,useMediaQuery/* default */.Z)("sm");
    const { locations  } = (0,store/* useTypedSelector */.ix)((state)=>state.config);
    const [nearbyDoctors, setNearbyDoctors] = (0,react.useState)([]);
    const [doctorsWithSlots, setDoctorsWithSlots] = (0,react.useState)([]);
    const enableCache = (0,useFeatureFlags/* useFeatureFlag */.y)(featureFlagConstants/* FeatureFlag.GROWTH_CACHED_SLOTS_ENABLED */.T.GROWTH_CACHED_SLOTS_ENABLED);
    (0,react.useEffect)(()=>{
        (0,api/* getNearbyDoctors */.$k)(coordinate.latitude, coordinate.longitude, radius).then((doctors)=>{
            if (!doctors) return;
            // @ts-expect-error TS2345: Argument of type 'Doctor[]' is not assignable to parameter of type 'SetStateAction<never[]>'.
            setNearbyDoctors(doctors.filter((d)=>d.hasPublicLandingPage));
        });
    }, [
        coordinate.latitude,
        coordinate.longitude,
        radius
    ]);
    (0,react.useEffect)(()=>{
        nearbyDoctors.filter(filter).map(async (p)=>{
            var _slots_flat, _slots_flat_;
            const slots = await (0,api/* loadAvailableSlots */.vk)({
                practiceId: p.practiceId,
                from: +moment_default()(),
                to: +moment_default()().add(7, "days").endOf("day"),
                duration: 20,
                doctorId: p.id,
                enableCache
            });
            return {
                ...p,
                primaryLocation: locations.findById(p.primaryLocationId),
                nextApptSlot: (_slots_flat = slots.flat()) === null || _slots_flat === void 0 ? void 0 : (_slots_flat_ = _slots_flat[0]) === null || _slots_flat_ === void 0 ? void 0 : _slots_flat_.time
            };
        }).sequence().then((results)=>{
            // @ts-expect-error TS2345: Argument of type 'ExtendedDoctor[]' is not assignable to parameter of type 'SetStateAction<never[]>'.
            setDoctorsWithSlots(results);
        });
    }, [
        locations,
        nearbyDoctors
    ]);
    const profileWidth = isSm ? 362 : 412;
    const leftPadding = 37;
    // @ts-expect-error TS2532: Object is possibly 'undefined'.
    const canProvidersScroll = width < profileWidth * doctorsWithSlots.length + leftPadding;
    // @ts-expect-error TS2532: Object is possibly 'undefined'.
    const profilesPerScroll = Math.floor(width / profileWidth);
    const scrollRight = ()=>{
        const providersContainer = document.getElementById("providers");
        // @ts-expect-error TS2531: Object is possibly 'null'.
        providersContainer.scrollBy(profileWidth * profilesPerScroll, 0);
    };
    const scrollLeft = ()=>{
        const providersContainer = document.getElementById("providers");
        // @ts-expect-error TS2531: Object is possibly 'null'.
        providersContainer.scrollBy(0 - profileWidth * profilesPerScroll, 0);
    };
    const filteredDoctors = doctorsWithSlots.filter(filter);
    // @ts-expect-error TS2322: Type 'false | Element' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>>'.
    return !filteredDoctors.isEmpty() && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "bg-gray50 oh pv24 contrast-tbt",
        "aria-label": i18n.t("Our primary care providers"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "pos-r pl7 hide-scroll-bars",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "df aife fdc-sm aifs-sm jcsb ph20 ph8-md ph6-sm ph3-xs pb10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    className: "fs12 font-mr ttu ls1 mv7-f gray600 db lh14",
                                    children: tag || i18n.t("Our primary care providers")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "mb4 fs40 fs32-md fs28-sm maxw35 maxw30-md font-csb lh1 pb4",
                                    children: header || [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                i18n.t("World-class providers. Inclusive healthcare."),
                                                " "
                                            ]
                                        }, "header1"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "darkGreen",
                                            children: i18n.t("A health team centered around you.")
                                        }, "header2")
                                    ]
                                })
                            ]
                        }),
                        filteredDoctors.length > 1 && canProvidersScroll && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsfe mb8 mb4-sm mt8-sm",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SkipSection/* default */.Z, {
                                    hrefs: [
                                        "insurance-heading",
                                        "footer"
                                    ],
                                    style: isSm ? {
                                        top: "9rem"
                                    } : {
                                        top: "4rem"
                                    },
                                    children: i18n.t("Skip Carousel")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    "aria-label": i18n.t("Scroll left."),
                                    className: "bg-gray800 br50 cp p2 cIcon-arrow-left mr4 otn brdn white fs30 contrast-tb",
                                    style: {
                                        width: 53,
                                        height: 53
                                    },
                                    onClick: scrollLeft
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    "aria-label": i18n.t("Scroll right."),
                                    className: "bg-gray800 br50 cp p2 cIcon-arrow-left otn brdn rotate-180 white fs30 contrast-tb",
                                    style: {
                                        width: 53,
                                        height: 53
                                    },
                                    onClick: scrollRight
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "providers",
                    className: "df",
                    style: {
                        overflow: "scroll",
                        scrollBehavior: "smooth"
                    },
                    children: filteredDoctors.map((p)=>// @ts-expect-error TS2339: Property 'id' does not exist on type 'never'.
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mr8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v5_OtherProvider, {
                                doctor: p
                            })
                        }, p.id))
                })
            ]
        })
    });
};
const OtherProvidersWrapper = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComp/* LazyComp */.P, {
        threshold: 750,
        visibleByDefault: Boolean(_constants/* isCI */.yg),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherProviders, {
            ...props
        })
    });
/* harmony default export */ var v5_OtherProviders = (OtherProvidersWrapper);


/***/ }),

/***/ 84661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);


const SkipSection = (param)=>{
    let { children , hrefs , style  } = param;
    const handleSpaceAndEnter = ()=>{
        for(let i = 0; i < hrefs.length; i += 1){
            const href = hrefs[i];
            const el = document.getElementById(href); // scroll to first element in hrefs found in DOM
            if (el) {
                window.location.href = "#".concat(href);
                el.focus();
                break;
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "pos-a-f bg-white gray800 ph4 pv3 br5 showOnFocus focus-bsDarkBlue3 brdn",
        style: style,
        onClick: handleSpaceAndEnter,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkipSection);


/***/ }),

/***/ 97455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _c10h_colors__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45602);
/* harmony import */ var _components_SkipSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84661);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32466);
/* harmony import */ var react_swipeable__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96808);
/* harmony import */ var src_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40367);
/* harmony import */ var _hooks_useClientSideId__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33437);
/* harmony import */ var _useMediaQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57974);
/* harmony import */ var _common_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93932);
/* harmony import */ var _common_Carbon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29946);











const TestimonialSlider = (param)=>{
    let { defaultTestimons , defaultHead , autoRotate , firstBgColor , firstTextColor , smallFont =false , ariaLabel  } = param;
    const [k, setK] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0);
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    const { isMobile  } = (0,src_store__WEBPACK_IMPORTED_MODULE_4__/* .useTypedSelector */ .ix)((param)=>{
        let { config  } = param;
        return config;
    });
    (0,_common_Carbon__WEBPACK_IMPORTED_MODULE_8__/* .useInterval */ .Yz)(()=>{
        if ((autoRotate || isMobile) && !_common_constants__WEBPACK_IMPORTED_MODULE_7__/* .isCI */ .yg) {
            setK((k + 1) % testimons.length);
        }
    }, 8000, false);
    const head = defaultHead || i18n.t("What our patients say");
    const testimons = defaultTestimons || [
        {
            body: i18n.t("I highly recommend them to anyone needing medical attention. Reservations are easy to set up via their app and recommended to avoid wait time. Yelp only allows for 5 stars. I would give them a 10."),
            who: {
                name: "Gary",
                who: i18n.t("Carbon Health San Francisco Patient")
            },
            bg: firstBgColor || _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerMint,
            color: firstTextColor || "#fff"
        },
        {
            body: i18n.t("Oh my God, finally an urgent care in our neighborhood that doesn't actually feel like an urgent care!  The space is super clean, modern, open and airy. The staff was excellent and were super friendly."),
            who: {
                name: "Gina",
                who: i18n.t("Carbon Health Los Angeles Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkPurple,
            color: "#fff"
        },
        {
            body: i18n.t("If I could give this place 10 stars, I would. I received exceptional service from the moment I walked in, to the time I left. This place has been the best urgent care location I've ever been to."),
            who: {
                name: "Steph",
                who: i18n.t("Carbon Health San Jose Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerYellow
        },
        {
            body: i18n.t("Literally amazing. They have the nicest doctors and staff, and you can get an appointment so easily and so fast! "),
            who: {
                name: "Liana",
                who: i18n.t("Carbon Health San Francisco Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkBlue
        },
        {
            body: i18n.t("Appreciated being seen immediately, the friendly and helpful staff, and my comprehensive care including x-rays, prescriptions called into my pharmacy and scheduling a follow-up appointment."),
            who: {
                name: "Laurie",
                who: i18n.t("Carbon Health Oakland Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerMint
        },
        {
            body: i18n.t("What I love is through their app (make sure you download the app - worth it) they check up on you to make sure you are ok. You are able to share any new developments."),
            who: {
                name: "Joeletta",
                who: i18n.t("Carbon Health Mountain View Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkPurple
        },
        {
            body: i18n.t("Great urgent care! Easy to make an appointment, got seen right away, the place was clean and tidy, and the staff was extremely friendly and helpful."),
            who: {
                name: "Tessa",
                who: i18n.t("Carbon Health Berkeley Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerYellow
        }
    ];
    const activeItem = testimons[k];
    const swipeHandlers = (0,react_swipeable__WEBPACK_IMPORTED_MODULE_10__/* .useSwipeable */ .QS)({
        onSwipedRight: ()=>isMobile && changeSlide(-1),
        onSwipedLeft: ()=>isMobile && changeSlide(1)
    });
    const changeSlide = (val)=>{
        const nextVal = k + val > testimons.length - 1 ? 0 : k + val < 0 ? testimons.length - 1 : k + val;
        setK(nextVal);
    };
    const isXs = (0,_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("xs");
    const headingId = (0,_hooks_useClientSideId__WEBPACK_IMPORTED_MODULE_5__/* .useClientSideId */ .i)();
    const carouselId = (0,_hooks_useClientSideId__WEBPACK_IMPORTED_MODULE_5__/* .useClientSideId */ .i)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "lg:py-36 md:py-16 pt-16 pb-10 relative text-white contrast-tbt max-w-screen transition-colors duration-500",
        style: {
            backgroundColor: testimons[k].bg
        },
        "aria-labelledby": headingId,
        "aria-roledescription": "carousel",
        ...ariaLabel && {
            "aria-label": ariaLabel
        },
        ...swipeHandlers,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative m-auto px-4 md:px-24",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SkipSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    hrefs: [
                        "explore-locations",
                        "footer"
                    ],
                    style: {
                        left: "2rem",
                        top: "-4rem"
                    },
                    children: i18n.t("Skip Carousel")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        !activeItem.hideHeadTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "font-ir fs13 op1 ls2 mb8 mt0 ttu",
                            id: headingId,
                            children: activeItem.head || head
                        }),
                        activeItem.headImg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mb8 minh20",
                            children: activeItem.headImg
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative overflow-hidden",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "transition-transform duration-500 grid grid-flow-col",
                                style: {
                                    gridAutoColumns: "100%",
                                    transform: "translateX(".concat(-100 * k, "%)")
                                },
                                id: carouselId,
                                "aria-live": autoRotate || isMobile ? "off" : "polite",
                                children: testimons.map((t, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("blockquote", {
                                        className: "t-op200 pos-r df fdc op0 brdn pl0 m0 ".concat(i === k ? "op1" : ""),
                                        role: "group",
                                        "aria-label": i18n.t(" {{number}} of {{total}}", {
                                            number: i + 1,
                                            total: testimons.length
                                        }),
                                        "aria-hidden": i !== k,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "font-cm mb8 ".concat(smallFont ? "fs28 fs18-md" : "fs40 fs24-md", " lh12 lh14-md maxw64 pb24 pb16-md fx"),
                                                children: t.body
                                            }),
                                            t.who && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "font-cm fs20 fs18-md mb2",
                                                children: t.who.name
                                            }),
                                            t.who && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "font-cm fs20 fs18-md lh14 maxw12-md",
                                                children: t.who.who
                                            }),
                                            t.source && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: t.source,
                                                rel: "noopener noreferrer",
                                                target: "_blank",
                                                className: "white fs14 font-ir us pos-a",
                                                style: {
                                                    bottom: 0
                                                },
                                                children: i18n.t("Source")
                                            })
                                        ]
                                    }, i))
                            })
                        })
                    ]
                }),
                testimons.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "df aic pos-a pos-r-xs mt4-xs",
                    style: isXs ? {} : {
                        right: "2rem",
                        bottom: isMobile ? ".25rem" : "-1rem"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "font-mb fs12 mr6 ttu",
                            children: i18n.t(" {{number}} of {{total}}", {
                                number: k + 1,
                                total: testimons.length
                            })
                        }),
                        !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    style: {
                                        backgroundColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerGreen + 33
                                    },
                                    onClick: ()=>changeSlide(-1),
                                    className: "cp br50 p2 fs36 cIcon-arrow-left mr4 brdn white contrast-tb",
                                    "aria-controls": carouselId,
                                    "aria-label": i18n.t("Previous")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    style: {
                                        backgroundColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerGreen + 33
                                    },
                                    onClick: ()=>changeSlide(1),
                                    className: "cp br50 p2 fs36 cIcon-arrow-right2 brdn white contrast-tb",
                                    "aria-controls": carouselId,
                                    "aria-label": i18n.t("Next")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TestimonialSlider);


/***/ }),

/***/ 69547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Tx": function() { return /* binding */ useFeaturedCareSlugs; }
});

// UNUSED EXPORTS: AllowedSpecialtyIdList, CareSlugList, ListsByPath, getFeaturedCareSlugs

// EXTERNAL MODULE: ./node_modules/memoizee/index.js
var memoizee = __webpack_require__(37453);
var memoizee_default = /*#__PURE__*/__webpack_require__.n(memoizee);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(21395);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
// EXTERNAL MODULE: ./src/constants/cares.ts
var cares = __webpack_require__(94700);
// EXTERNAL MODULE: ./src/constants/MsMap.ts
var MsMap = __webpack_require__(56776);
// EXTERNAL MODULE: ./src/constants/specialtyIds.ts
var specialtyIds = __webpack_require__(93209);
// EXTERNAL MODULE: ./node_modules/lodash/uniq.js
var uniq = __webpack_require__(7986);
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/store/slices/userLocation.ts
var userLocation = __webpack_require__(36330);
;// CONCATENATED MODULE: ./src/hooks/useSpecialtiesInRegion.ts




const getRegionFromLoc = (l)=>l.region.slug;
const buildRegionSpecialtyMap = memoizee_default()((locations)=>locations.reduce((acc, next)=>{
        const key = getRegionFromLoc(next);
        const prevList = acc[key] || [];
        return {
            ...acc,
            [key]: uniq_default()([
                ...prevList,
                ...next.specialtyIds
            ])
        };
    }, {}));
const useSpecialtiesInRegion = ()=>{
    const locations = useTypedSelector((state)=>state.config.locations);
    const selectedRegion = useTypedSelector(selectSelectedRegion);
    const map = locations && buildRegionSpecialtyMap(locations);
    return map ? map[selectedRegion] : [];
};

;// CONCATENATED MODULE: ./src/utils/doListsContainSameElements.ts
/**
 * Checks that each list has the same length and contains the same values, in any order.
 * Only checks referential equality.
 */ const doListsContainSameElements = (list1, list2)=>list1.length === list2.length && list1.every((item)=>list2.includes(item));

;// CONCATENATED MODULE: ./src/utils/getFeaturedCares.ts










const allowedSpecialtyIds = [
    specialtyIds/* SpecialtyId.PRIMARY_CARE */.mg.PRIMARY_CARE,
    specialtyIds/* SpecialtyId.URGENT_CARE */.mg.URGENT_CARE,
    specialtyIds/* SpecialtyId.OCCUPATIONAL_HEALTH */.mg.OCCUPATIONAL_HEALTH,
    specialtyIds/* SpecialtyId.COVID_TESTING_MOBILE */.mg.COVID_TESTING_MOBILE,
    specialtyIds/* SpecialtyId.COVID_TRAVEL_CLEARANCE */.mg.COVID_TRAVEL_CLEARANCE
];
const isAllowedSpecialtyId = (val)=>allowedSpecialtyIds.includes(val);
const AllowedSpecialtyIdList = {
    ALL: allowedSpecialtyIds,
    WITHOUT_PC: [
        specialtyIds/* SpecialtyId.URGENT_CARE */.mg.URGENT_CARE,
        specialtyIds/* SpecialtyId.OCCUPATIONAL_HEALTH */.mg.OCCUPATIONAL_HEALTH,
        specialtyIds/* SpecialtyId.COVID_TESTING_MOBILE */.mg.COVID_TESTING_MOBILE,
        specialtyIds/* SpecialtyId.COVID_TRAVEL_CLEARANCE */.mg.COVID_TRAVEL_CLEARANCE
    ],
    WITHOUT_OCC: [
        specialtyIds/* SpecialtyId.PRIMARY_CARE */.mg.PRIMARY_CARE,
        specialtyIds/* SpecialtyId.URGENT_CARE */.mg.URGENT_CARE,
        specialtyIds/* SpecialtyId.COVID_TESTING_MOBILE */.mg.COVID_TESTING_MOBILE,
        specialtyIds/* SpecialtyId.COVID_TRAVEL_CLEARANCE */.mg.COVID_TRAVEL_CLEARANCE
    ],
    WITHOUT_PC_OCC: [
        specialtyIds/* SpecialtyId.URGENT_CARE */.mg.URGENT_CARE,
        specialtyIds/* SpecialtyId.COVID_TESTING_MOBILE */.mg.COVID_TESTING_MOBILE,
        specialtyIds/* SpecialtyId.COVID_TRAVEL_CLEARANCE */.mg.COVID_TRAVEL_CLEARANCE
    ],
    WITHOUT_PC_OCC_TRAVEL: [
        specialtyIds/* SpecialtyId.URGENT_CARE */.mg.URGENT_CARE,
        specialtyIds/* SpecialtyId.COVID_TESTING_MOBILE */.mg.COVID_TESTING_MOBILE
    ],
    ONLY_PC: [
        specialtyIds/* SpecialtyId.PRIMARY_CARE */.mg.PRIMARY_CARE
    ],
    ONLY_TRAVEL: [
        specialtyIds/* SpecialtyId.COVID_TRAVEL_CLEARANCE */.mg.COVID_TRAVEL_CLEARANCE
    ]
};
const CareSlugList = {
    HOME_WITH_ALL: [
        cares/* CareSlug.PRIMARY_CARE */.s.PRIMARY_CARE,
        cares/* CareSlug.URGENT_CARE */.s.URGENT_CARE,
        cares/* CareSlug.COVID_CARE */.s.COVID_CARE,
        cares/* CareSlug.ANNUAL_PHYSICAL */.s.ANNUAL_PHYSICAL,
        cares/* CareSlug.COLD_AND_FLU */.s.COLD_AND_FLU,
        cares/* CareSlug.WORKPLACE_HEALTH */.s.WORKPLACE_HEALTH,
        cares/* CareSlug.COVID_TRAVEL_TESTING */.s.COVID_TRAVEL_TESTING,
        cares/* CareSlug.INJURY */.s.INJURY
    ],
    HOME_WITHOUT_PC: [
        cares/* CareSlug.URGENT_CARE */.s.URGENT_CARE,
        cares/* CareSlug.COVID_CARE */.s.COVID_CARE,
        cares/* CareSlug.COLD_AND_FLU */.s.COLD_AND_FLU,
        cares/* CareSlug.WORKPLACE_HEALTH */.s.WORKPLACE_HEALTH,
        cares/* CareSlug.COVID_TRAVEL_TESTING */.s.COVID_TRAVEL_TESTING,
        cares/* CareSlug.INJURY */.s.INJURY,
        cares/* CareSlug.URINARY_TRACT_INFECTION */.s.URINARY_TRACT_INFECTION,
        cares/* CareSlug.RASH */.s.RASH
    ],
    HOME_WITHOUT_OCC: [
        cares/* CareSlug.PRIMARY_CARE */.s.PRIMARY_CARE,
        cares/* CareSlug.URGENT_CARE */.s.URGENT_CARE,
        cares/* CareSlug.COVID_CARE */.s.COVID_CARE,
        cares/* CareSlug.ANNUAL_PHYSICAL */.s.ANNUAL_PHYSICAL,
        cares/* CareSlug.COLD_AND_FLU */.s.COLD_AND_FLU,
        cares/* CareSlug.COVID_TRAVEL_TESTING */.s.COVID_TRAVEL_TESTING,
        cares/* CareSlug.INJURY */.s.INJURY,
        cares/* CareSlug.URINARY_TRACT_INFECTION */.s.URINARY_TRACT_INFECTION
    ],
    HOME_WITHOUT_PC_OCC: [
        cares/* CareSlug.URGENT_CARE */.s.URGENT_CARE,
        cares/* CareSlug.COVID_CARE */.s.COVID_CARE,
        cares/* CareSlug.COLD_AND_FLU */.s.COLD_AND_FLU,
        cares/* CareSlug.COVID_TRAVEL_TESTING */.s.COVID_TRAVEL_TESTING,
        cares/* CareSlug.INJURY */.s.INJURY,
        cares/* CareSlug.RASH */.s.RASH,
        cares/* CareSlug.URINARY_TRACT_INFECTION */.s.URINARY_TRACT_INFECTION,
        cares/* CareSlug.EAR_ACHE */.s.EAR_ACHE
    ],
    CLINIC_WITH_ALL: [
        cares/* CareSlug.PRIMARY_CARE */.s.PRIMARY_CARE,
        cares/* CareSlug.URGENT_CARE */.s.URGENT_CARE,
        cares/* CareSlug.COVID_CARE */.s.COVID_CARE,
        cares/* CareSlug.ANNUAL_PHYSICAL */.s.ANNUAL_PHYSICAL,
        cares/* CareSlug.COLD_AND_FLU */.s.COLD_AND_FLU,
        cares/* CareSlug.WORKPLACE_HEALTH */.s.WORKPLACE_HEALTH,
        cares/* CareSlug.COVID_TRAVEL_TESTING */.s.COVID_TRAVEL_TESTING,
        cares/* CareSlug.INJURY */.s.INJURY
    ],
    CLINIC_WITHOUT_PC: [
        cares/* CareSlug.URGENT_CARE */.s.URGENT_CARE,
        cares/* CareSlug.COVID_CARE */.s.COVID_CARE,
        cares/* CareSlug.COLD_AND_FLU */.s.COLD_AND_FLU,
        cares/* CareSlug.WORKPLACE_HEALTH */.s.WORKPLACE_HEALTH,
        cares/* CareSlug.COVID_TRAVEL_TESTING */.s.COVID_TRAVEL_TESTING,
        cares/* CareSlug.INJURY */.s.INJURY,
        cares/* CareSlug.URINARY_TRACT_INFECTION */.s.URINARY_TRACT_INFECTION,
        cares/* CareSlug.RASH */.s.RASH
    ],
    CLINIC_WITHOUT_OCC: [
        cares/* CareSlug.PRIMARY_CARE */.s.PRIMARY_CARE,
        cares/* CareSlug.URGENT_CARE */.s.URGENT_CARE,
        cares/* CareSlug.COVID_CARE */.s.COVID_CARE,
        cares/* CareSlug.ANNUAL_PHYSICAL */.s.ANNUAL_PHYSICAL,
        cares/* CareSlug.COLD_AND_FLU */.s.COLD_AND_FLU,
        cares/* CareSlug.COVID_TRAVEL_TESTING */.s.COVID_TRAVEL_TESTING,
        cares/* CareSlug.INJURY */.s.INJURY,
        cares/* CareSlug.URINARY_TRACT_INFECTION */.s.URINARY_TRACT_INFECTION
    ],
    CLINIC_WITHOUT_PC_OCC: [
        cares/* CareSlug.URGENT_CARE */.s.URGENT_CARE,
        cares/* CareSlug.COVID_CARE */.s.COVID_CARE,
        cares/* CareSlug.COLD_AND_FLU */.s.COLD_AND_FLU,
        cares/* CareSlug.COVID_TRAVEL_TESTING */.s.COVID_TRAVEL_TESTING,
        cares/* CareSlug.INJURY */.s.INJURY,
        cares/* CareSlug.URINARY_TRACT_INFECTION */.s.URINARY_TRACT_INFECTION,
        cares/* CareSlug.RASH */.s.RASH,
        cares/* CareSlug.EAR_ACHE */.s.EAR_ACHE
    ],
    CLINIC_WITHOUT_PC_OCC_TRAVEL: [
        cares/* CareSlug.URGENT_CARE */.s.URGENT_CARE,
        cares/* CareSlug.COVID_CARE */.s.COVID_CARE,
        cares/* CareSlug.COLD_AND_FLU */.s.COLD_AND_FLU,
        cares/* CareSlug.INJURY */.s.INJURY,
        cares/* CareSlug.URINARY_TRACT_INFECTION */.s.URINARY_TRACT_INFECTION,
        cares/* CareSlug.RASH */.s.RASH,
        cares/* CareSlug.EAR_ACHE */.s.EAR_ACHE,
        cares/* CareSlug.SORE_THROAT */.s.SORE_THROAT
    ],
    CLINIC_WITH_TRAVEL_ONLY: [
        cares/* CareSlug.COVID_TRAVEL_TESTING */.s.COVID_TRAVEL_TESTING,
        cares/* CareSlug.SAME_DAY_RT_PCR */.s.SAME_DAY_RT_PCR,
        cares/* CareSlug.SAME_DAY_ANTIGEN */.s.SAME_DAY_ANTIGEN,
        cares/* CareSlug.SAME_DAY_NAAT */.s.SAME_DAY_NAAT,
        cares/* CareSlug.NEXT_DAY_RT_PCR */.s.NEXT_DAY_RT_PCR
    ],
    CLINIC_WITH_PRIMARY_ONLY: [
        cares/* CareSlug.ANNUAL_PHYSICAL */.s.ANNUAL_PHYSICAL,
        cares/* CareSlug.WELLNESS_VISIT */.s.WELLNESS_VISIT,
        cares/* CareSlug.WOMENS_HEALTH */.s.WOMENS_HEALTH,
        cares/* CareSlug.LGBTQ_HEALTH */.s.LGBTQ_HEALTH,
        cares/* CareSlug.EXISTING_CONDITION */.s.EXISTING_CONDITION,
        cares/* CareSlug.FAMILY_PLANNING */.s.FAMILY_PLANNING,
        cares/* CareSlug.STI */.s.STI,
        cares/* CareSlug.SPORTS_PHYSICAL */.s.SPORTS_PHYSICAL
    ]
};
const ListsByPath = {
    [_constants/* v5Pages.home */.Td.home]: [
        {
            specialtyIds: AllowedSpecialtyIdList.ALL,
            careSlugs: CareSlugList.HOME_WITH_ALL
        },
        {
            specialtyIds: AllowedSpecialtyIdList.WITHOUT_PC,
            careSlugs: CareSlugList.HOME_WITHOUT_PC
        },
        {
            specialtyIds: AllowedSpecialtyIdList.WITHOUT_OCC,
            careSlugs: CareSlugList.HOME_WITHOUT_OCC
        },
        {
            specialtyIds: AllowedSpecialtyIdList.WITHOUT_PC_OCC,
            careSlugs: CareSlugList.HOME_WITHOUT_PC_OCC
        }
    ],
    [_constants/* v5Pages.clinicDetails */.Td.clinicDetails]: [
        {
            specialtyIds: AllowedSpecialtyIdList.ALL,
            careSlugs: CareSlugList.CLINIC_WITH_ALL
        },
        {
            specialtyIds: AllowedSpecialtyIdList.WITHOUT_PC,
            careSlugs: CareSlugList.CLINIC_WITHOUT_PC
        },
        {
            specialtyIds: AllowedSpecialtyIdList.WITHOUT_OCC,
            careSlugs: CareSlugList.CLINIC_WITHOUT_OCC
        },
        {
            specialtyIds: AllowedSpecialtyIdList.WITHOUT_PC_OCC,
            careSlugs: CareSlugList.CLINIC_WITHOUT_PC_OCC
        },
        {
            specialtyIds: AllowedSpecialtyIdList.WITHOUT_PC_OCC_TRAVEL,
            careSlugs: CareSlugList.CLINIC_WITHOUT_PC_OCC_TRAVEL
        },
        {
            specialtyIds: AllowedSpecialtyIdList.ONLY_TRAVEL,
            careSlugs: CareSlugList.CLINIC_WITH_TRAVEL_ONLY
        },
        {
            specialtyIds: AllowedSpecialtyIdList.ONLY_PC,
            careSlugs: CareSlugList.CLINIC_WITH_PRIMARY_ONLY
        }
    ]
};
const isValidPath = (pathname)=>Object.keys(ListsByPath).includes(pathname);
const getFeaturedCareSlugs = memoizee_default()(function(pathname) {
    let specialtyIds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : allowedSpecialtyIds;
    var _ListsByPath_key_find;
    const key = isValidPath(pathname) ? pathname : null;
    const filteredSpecialtyIds = specialtyIds.filter(isAllowedSpecialtyId);
    const defaultList = pathname === _constants/* v5Pages.home */.Td.home ? CareSlugList.HOME_WITHOUT_PC_OCC : CareSlugList.CLINIC_WITHOUT_PC_OCC_TRAVEL;
    return key ? ((_ListsByPath_key_find = ListsByPath[key].find((set)=>doListsContainSameElements(filteredSpecialtyIds, set.specialtyIds.filter(isAllowedSpecialtyId)))) === null || _ListsByPath_key_find === void 0 ? void 0 : _ListsByPath_key_find.careSlugs) || defaultList : defaultList;
}, {
    normalizer: JSON.stringify,
    maxAge: MsMap/* MsMap.ONE_MINUTE */.I.ONE_MINUTE
});
const useFeaturedCareSlugs = (specialtyIdsOverride)=>{
    const { pathname  } = (0,router.useRouter)();
    const { locations , locationsSorted  } = (0,store/* useTypedSelector */.ix)((state)=>state.config);
    const selectedRegion = (0,store/* useTypedSelector */.ix)(userLocation/* selectSelectedRegion */.dz);
    const map = !specialtyIdsOverride && locationsSorted && selectedRegion && locations && buildRegionSpecialtyMap(locations);
    const specialtyIds = specialtyIdsOverride || map && map[selectedRegion].filter(isAllowedSpecialtyId) || undefined;
    return getFeaturedCareSlugs(pathname, specialtyIds);
};


/***/ }),

/***/ 13521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BB": function() { return /* binding */ getLocationSchemas; },
/* harmony export */   "fK": function() { return /* binding */ schema; },
/* harmony export */   "nk": function() { return /* binding */ convertHours; }
/* harmony export */ });
/* harmony import */ var _components_common_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93932);
/* harmony import */ var _constants_specialtyIds__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93209);


const covidTestingIds = [
    _constants_specialtyIds__WEBPACK_IMPORTED_MODULE_1__/* .SpecialtyId.COVID_SEROLOGY */ .mg.COVID_SEROLOGY,
    _constants_specialtyIds__WEBPACK_IMPORTED_MODULE_1__/* .SpecialtyId.COVID_TESTING_RAPID */ .mg.COVID_TESTING_RAPID,
    _constants_specialtyIds__WEBPACK_IMPORTED_MODULE_1__/* .SpecialtyId.COVID_TESTING_MOBILE */ .mg.COVID_TESTING_MOBILE
];
const dayMap = {
    "0": "Su",
    "1": "Mo",
    "2": "Tu",
    "3": "We",
    "4": "Th",
    "5": "Fr",
    "6": "Sa"
};
const schema = {
    website: "https://carbonhealth.com",
    name: "Carbon Health",
    title: "A fresh take on health care | Carbon Health",
    description: "A new Primary Care clinic that works with your busy life",
    logo: "https://carbonhealth.com/static/img/_common/logo_200.jpg",
    address: {
        addressCountry: "United States",
        addressLocality: "San Francisco",
        addressRegion: "CA",
        postalCode: "94104",
        streetAddress: "300 California St. 7th Floor",
        email: "support@carbonhealth.com",
        telephone: "+1-415-612-3256",
        latitude: "37.793450",
        longitude: "-122.400340"
    }
};
const convertHours = (timeBlock)=>{
    const dayGroupsByRange = timeBlock.groupBy((x)=>"".concat(x.from, "-").concat(x.to));
    return dayGroupsByRange.getKeys().map((timeRange)=>{
        // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{ "0": string; "1": string; "2": string; "3": string; "4": string; "5": string; "6": string; }'.
        const days = dayGroupsByRange[timeRange].map((timeBlock)=>dayMap[timeBlock.day]).join(",");
        return "".concat(days, " ").concat(timeRange);
    }).join(", ");
};
const getLocationSchemas = (location, image)=>{
    const hourBlock = location.specialties[location.specialtyIds[0]].hours;
    const url = "".concat(_components_common_constants__WEBPACK_IMPORTED_MODULE_0__/* .host */ .ho, "/locations/").concat(location.slug);
    return [
        {
            "@context": "https://schema.org",
            "@type": "MedicalClinic",
            isAcceptingNewPatients: true,
            image,
            address: {
                "@type": "PostalAddress",
                addressLocality: location.address.city,
                addressRegion: location.address.state,
                postalCode: location.address.zip,
                streetAddress: location.address.firstLine
            },
            description: "",
            name: "Carbon Health",
            openingHours: convertHours(hourBlock),
            telephone: location.phoneNumber,
            url,
            paymentAccepted: "Cash, Credit Card, Insurance"
        },
        covidTestingIds.some((id)=>location.specialtyIds.includes(id)) && {
            "@context": "https://schema.org",
            "@type": "CovidTestingFacility",
            name: "Carbon Health Urgent Care",
            image,
            address: {
                addressLocality: location.address.city,
                addressRegion: location.address.state,
                postalCode: location.address.zip,
                streetAddress: location.address.firstLine,
                telephone: location.phoneNumber,
                url
            }
        }
    ].compact().map((s)=>JSON.stringify(s));
};


/***/ })

}]);